import { ServiciosbasicosService } from './../../../services/serviciosbasicos/serviciosbasicos.service';
import { EnviarmensajeService } from './../../../services/enviarmensaje/enviarmensaje.service';
import { UsuarioService } from './../../../services/usuario/usuario.service';
import { Component, OnInit } from '@angular/core';
declare function inicializarPluginsSidebar();

@Component({
  selector: 'app-dashadmin',
  templateUrl: './dashadmin.component.html',
  styleUrls: ['./dashadmin.component.css']
})
export class DashadminComponent implements OnInit {

  arrendador = 'ARRENDADOR';
  arrendatario = 'ARRENDATARIO';

  totalArrendadoresActivados = 0;
  totalArrendadoresDesactivados = 0;

  totalArrendatariosActivados = 0;
  totalArrendatariosDesactivados = 0;

  mensajesNoLeidos = 0;
  serviciosBasicosRegistrados = 0;

  constructor(public _usuarioService: UsuarioService, public _enviarMensajeService: EnviarmensajeService, public _basicosService: ServiciosbasicosService) { }

  ngOnInit(): void {
    inicializarPluginsSidebar();
    this.cargarUsuariosAdminArrendadorArrendador(this.arrendador);
    this.cargarUsuariosAdminArrendadorArrendador(this.arrendatario);
    this.cargarMensajesNoLeidos();
    this.cargarServicios();
  }

  cargarUsuariosAdminArrendadorArrendador(rol: string) {
    this._usuarioService.obtenerUsuariosArrendadoresDasAdmin(rol)
      .subscribe((resp: any) => {
        if(rol === this.arrendador){
          this.totalArrendadoresActivados = resp.activados;
          this.totalArrendadoresDesactivados = resp.desactivados;
        }if(rol === this.arrendatario){
          this.totalArrendatariosActivados = resp.activados;
          this.totalArrendatariosDesactivados = resp.desactivados;
        }
      });
  }

  cargarMensajesNoLeidos(){
    this._enviarMensajeService.cargarMensajesNoLeidos()
    .subscribe( mensajes => this.mensajesNoLeidos = mensajes);
  }

  cargarServicios(){
    this._basicosService.cargarServicios(0)
    .subscribe( servicios => this.serviciosBasicosRegistrados = this._basicosService.totalServicios);
  }

}
